<template>
  <div class="supermarket">
    <van-row
      class="supermarket-search"
      @scroll="handleScroll"
      :class="{ supermarketFixedTop: supermarketFixedTop, isiOSX: isiOSX }"
      id="changeSearch"
    >
      <img
        class="back"
        src="../../assets/selfSupport/backbefore@2x.png"
        @click="goBack()"
      />

      <h2><img class="littleTitle" :src="logo" /></h2>
      <img class="search" :src="searchImgT" v-if="current == 0" />
      <img
        class="search search1"
        :src="searchImgT"
        :style="searchColor"
        v-if="current == 1"
      />
      <img
        class="share"
        src="../../assets/selfSupport/share.png"
        @click="supportSM()"
      />
      <van-search v-model="value" @click="searchSM()" readonly />
    </van-row>
    <div class="supermarket-content">
      <van-swipe
        class="supermarket-swipe"
        v-if="swiper.length > 0"
        @change="onChange"
      >
        <van-swipe-item v-for="(item, index) in swiper" :key="index">
          <img
            class="item"
            :style="bodyWidth"
            :src="item.img_url"
            @error="defaultPro()"
            @click="Router(item.href)"
          />
        </van-swipe-item>
      </van-swipe>
      <!---->
      <van-row class="supermarket-adv" :style="advTop" v-if="adv[0]">
        <img
          :src="adv[0].img_url"
          @error="advDefault()"
          @click="dftAdv(adv[0].href)"
        />
      </van-row>

      <!--<van-row class="supermarket-notice" @click="noticeSM()" v-if="shopNotic" :style="noticeTop">
				<van-col span="24">
					<img src="../../assets/selfSupport/gonggao.png"/>
					<span class="hot">HOT</span>
					<van-notice-bar :text="shopNotic"/>
				</van-col>
			</van-row>-->

      <div
        class="supermarket-model1"
        :class="{ 'model1-scroller': isA1 }"
        v-if="topCate"
        :style="advMargin"
      >
        <div
          class="supermarket-swipeBox content"
          :class="{ 'class-a': isA1 }"
          @scroll="handleScroll1"
        >
          <div class="swipeBox" :style="scrollWidth">
            <div
              class="label"
              v-for="(item, index) in topCate"
              :key="index"
              :style="topCateW"
            >
              <div @click="classify1(item.id)">
                <img :src="item.icon" @error="iconDefu()" />
              </div>
              <div class="classfity">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <p class="scrollBar" v-show="isScroll">
          <span class="outside">
            <span class="inside" :style="insideSty"></span>
          </span>
        </p>
      </div>

      <!-- <van-row class="supermarket-spike" v-if="miaoshaShow && miaosha_data.list">
				<div class="box">
					<van-col class="title" span="24">
						<img src="../../assets/selfSupport/miaoshadanpin.png" />
						<van-count-down :time="time1">
						  <template v-slot="timeData">
						    <span>{{checkTime(timeData.hours)}}</span> : <span>{{checkTime(timeData.minutes)}}</span> : <span>{{checkTime(timeData.seconds)}}</span>
						  </template>
						</van-count-down>
					</van-col>
					<van-col class="label" span="12">
						<span class="time">正在进行{{miaoshaBegin}}点场</span>
					</van-col>
					<van-col class="more" offset="4" span="8">
						<div @click="moreSpikeSM()">
							更多<img src="../../assets/selfSupport/moreMiddle.png" />
						</div>
					</van-col>
					<div class="wrapper">
						<div class="datePrice">
							<ul class="clearfix">
								<li :style="recommendstyle" v-for="(item,index) in miaosha_data.list" :key="index" v-if="index < 3">
									<div class="imgCon" :style="recommendstyle_img">
										<img class="imgPro" :src="item.thumb" @error="defaultPro()" @click="goDetail1(item.id)"/>
									</div>
									<p class="name" @click="goDetail1(item.id)">
										{{item.name}}</p>
									<p class="price">￥{{item.show_min_price}}<del v-if="item.strikeout_price && item.strikeout_price!=0">￥{{item.strikeout_price}}</del><del v-else>￥{{item.activity_min_price}}</del></p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</van-row> -->

      <!-- <div class="supermarket-dayrec" v-if="dayGoods">
				<div class="wrap">
					<van-row class="box">
						<van-col class="title" span="24">
							<img class="word" src="../../assets/selfSupport/meirihaohuo.png" />
							<img class="more" @click="moreDayrecSM()" src="../../assets/selfSupport/moreBig.png" />
						</van-col>
						<van-col class="label" span="24">
							<span @click="moreDayrecSM()">发现世界好物<img src="../../assets/selfSupport/moreLittle.png" /></span>
						</van-col>
					</van-row>
					<van-row class="dayrec-list">
						<van-col span="8" v-for="(item, index) in dayGoods" :key="index" v-if="index < 3" >
					  	<img :src="item.images" @error="defaultPro()" :style="dayGoodsH" @click="adv1(item.route_url)"/>
					  </van-col>
					</van-row>
				</div>
			</div> -->

      <!-- 拼团活动 -->
      <img
        v-if="ptAd"
        :src="ptAd.img_url"
        alt=""
        class="groupbuy"
        @click="ptAdv(ptAd.href)"
      />

      <div
        class="supermarket-active"
        v-if="reductionShow && reduction_data.goods"
      >
        <div class="wrap">
          <van-row class="tit">
            <div @click="reductionSM()">
              <van-col span="12" class="leftT"
                ><span>满额立减</span
                ><img src="../../assets/selfSupport/moreBig.png"
              /></van-col>
              <van-col span="12" class="rightT">距结束仅剩</van-col>
              <van-col span="12" class="leftB"
                >最高立减<span>{{
                  reduction_data.activity.requirements[0].discount_amount
                }}</span
                >元</van-col
              >
              <van-col span="12" class="rightB">
                <van-count-down :time="time2">
                  <template v-slot="timeData">
                    <span>{{ checkTime(timeData.days) }}</span
                    >天<span>{{ checkTime(timeData.hours) }}</span
                    >时<span>{{ checkTime(timeData.minutes) }}</span
                    >分<span>{{ checkTime(timeData.seconds) }}</span
                    >秒
                  </template>
                </van-count-down>
              </van-col>
            </div>
          </van-row>
          <van-row class="product">
            <van-col
              span="8"
              v-for="(item, index) in reduction_data.goods"
              :key="index"
              v-if="index < 3"
            >
              <div class="img">
                <img
                  class="imgPro"
                  @click="goDetail1(item.id)"
                  :src="item.thumb"
                  @error="defaultPro()"
                  :style="reductionH"
                />
                <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
              </div>
              <p class="name" @click="goDetail1(item.id)">
                <!-- <span class="label_zy">自营</span> -->
                {{ item.name }}
              </p>
              <p class="price">￥{{ item.activity_min_price }}</p>
            </van-col>
          </van-row>
        </div>
      </div>

      <div
        class="supermarket-active supermarket-active2"
        v-if="fullpackageShow && fullpackage_data.goods"
      >
        <div class="wrap">
          <van-row class="tit">
            <div @click="fullpackageSM()">
              <van-col span="12" class="leftT"
                ><span>满额包邮</span
                ><img src="../../assets/selfSupport/moreBig.png"
              /></van-col>
              <van-col span="12" class="rightT">距结束仅剩</van-col>
              <van-col span="12" class="leftB"
                >满<span>{{
                  fullpackage_data.activity.amount_requirements
                }}</span
                >元包邮</van-col
              >
              <van-col span="12" class="rightB">
                <van-count-down :time="time3">
                  <template v-slot="timeData">
                    <span>{{ checkTime(timeData.days) }}</span
                    >天<span>{{ checkTime(timeData.hours) }}</span
                    >时<span>{{ checkTime(timeData.minutes) }}</span
                    >分<span>{{ checkTime(timeData.seconds) }}</span
                    >秒
                  </template>
                </van-count-down>
              </van-col>
            </div>
          </van-row>
          <van-row class="product" v-if="fullpackage_data.goods">
            <van-col
              span="8"
              v-for="(item, index) in fullpackage_data.goods"
              :key="index"
              v-if="index < 3"
            >
              <div class="img">
                <img
                  class="imgPro"
                  @click="goDetail1(item.id)"
                  :src="item.thumb"
                  @error="defaultPro()"
                  :style="reductionH"
                />
                <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
              </div>
              <p class="name" @click="goDetail1(item.id)">
                <!-- <span class="label_zy">自营</span> -->
                {{ item.name }}
              </p>
              <p class="price">￥{{ item.activity_min_price }}</p>
            </van-col>
          </van-row>
        </div>
      </div>
      <van-row class="supermarket-like" v-if="listL">
        <van-col class="title" span="24">
          <p>
            <span class="label"></span
            ><span class="like">{{ lovely_big_title }}</span
            ><span class="tip">{{ lovely_small_title }}</span>
          </p>
        </van-col>
      </van-row>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="listL">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="别拉了，小巴也是有底线的"
          @load="onLoad"
        >
          <van-row class="supermarket-like">
            <van-col span="12">
              <div
                class="goods leftGoods"
                v-for="(item, index) in listL"
                :key="index"
              >
                <div class="img">
                  <img
                    class="imgPro"
                    @click="goDetail1(item.id)"
                    :src="item.thumb"
                    @error="defaultPro()"
                    :style="likestyle"
                  />
                  <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
                </div>
                <div @click="goDetail1(item.id)">
                  <p class="label">
                    <!-- <span class="label_zy">自营</span> -->
                    <span class="label_zy label_mj" v-show="item.discount == 1"
                      >满减</span
                    ><span
                      class="label_zy label_by"
                      v-show="item.postage_free == 1"
                      >包邮</span
                    >
                  </p>
                  <p class="name">
                    <img :src="item.label" v-if="item.label" />
                    <img :src="item.tag_icon" v-if="item.tag_icon" />
                    {{ item.name }}
                  </p>
                  <p class="price">
                    ￥{{ item.activity_min_price }}
                    <del
                      v-if="item.strikeout_price && item.strikeout_price != 0"
                      >￥{{ item.strikeout_price }}</del
                    ><del v-else>￥{{ item.activity_max_price }}</del>
                  </p>
                </div>
              </div>
            </van-col>
            <van-col span="12">
              <div
                class="goods rightGoods"
                v-for="(item, index) in listR"
                :key="index"
              >
                <div class="img">
                  <img
                    class="imgPro"
                    @click="goDetail1(item.id)"
                    :src="item.thumb"
                    @error="defaultPro()"
                    :style="likestyle"
                  />
                  <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
                </div>
                <div @click="goDetail1(item.id)">
                  <p class="label">
                    <!-- <span class="label_zy">自营</span> -->
                    <span class="label_zy label_mj" v-show="item.discount == 1"
                      >满减</span
                    ><span
                      class="label_zy label_by"
                      v-show="item.postage_free == 1"
                      >包邮</span
                    >
                  </p>
                  <p class="name">
                    <img :src="item.label" v-if="item.label" />
                    <img :src="item.tag_icon" v-if="item.tag_icon" />
                    {{ item.name }}
                  </p>
                  <p class="price">
                    ￥{{ item.activity_min_price }}
                    <del
                      v-if="item.strikeout_price && item.strikeout_price != 0"
                      >￥{{ item.strikeout_price }}</del
                    ><del v-else>￥{{ item.activity_max_price }}</del>
                  </p>
                </div>
              </div>
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import searchbefore from "@/assets/selfSupport/searchbefore_super@2x.png";

import defaultImg from "@/assets/common/ListPreload.png";
import productDefault from "@/assets/common/preload.png";
import defaultIcon from "@/assets/selfSupport/marketResult.jpg";

const adMap = {
  1: "shallBuy_supermarket_first_third",
  2: "shallBuy_equipment_first_third",
  5: "shallBuy_clothes_first_third",
  6: "shallBuy_jewelry_first_third",
  8: "shallBuy_typ_first_third",
};

export default {
  data() {
    return {
      value: "", //旺仔小牛奶
      supermarketFixedTop: false,
      searchImgT: searchbefore,

      current: 0,
      isiOSX: false,
      isA1: false, //控制分类区域class
      isScroll: false,
      logo: "",
      swiper: [],
      adv: [], //广告位
      shopNotic: "", //店铺公告
      // dayGoods: [],//每日好货
      // miaosha_data: {},//秒杀单品
      topCate: [], //分类
      miaoshaBegin: "", //秒杀场次
      downcount: {
        //秒杀结束倒计时
        hh: "",
        mm: "",
        ss: "",
      },
      reduction_downcount: {
        //满减结束倒计时
        dd: "",
        hh: "",
        mm: "",
        ss: "",
      },
      fullpackage_downcount: {
        //满额包邮结束倒计时
        dd: "",
        hh: "",
        mm: "",
        ss: "",
      },
      // miaoshaShow: true,//秒杀是否显示
      reductionShow: true, //满额立减是否显示
      reduction_data: {}, //满额立减数据
      fullpackageShow: true, //满额包邮是否显示
      fullpackage_data: {}, //满额包邮数据
      recommendstyle: {
        //秒杀单品样式
        width: (document.body.clientWidth - 80) / 3 + "px",
        //	      width: document.body.clientWidth * 0.24 + 'px'
        //	      'white-space': 'normal'
      },
      recommendstyle_img: {
        width: (document.body.clientWidth - 80) / 3 + "px",
        height: (document.body.clientWidth - 80) / 3 + "px",
      },
      // dayGoodsH:{//每日好货样式
      //   height: (document.body.clientWidth - 48) / 3 + 'px'
      // },
      reductionH: {
        //满额立减和满额包邮样式
        height: (document.body.clientWidth - 32) / 3 - 12 + "px",
      },
      likestyle: {
        height: (document.body.clientWidth - 34) / 2 + "px",
      },
      topCateW: {
        width: (document.body.clientWidth - 16) / 5 + "px",
      },
      bodyWidth: {
        height: document.body.clientWidth + "px",
      },
      advTop: {
        top: document.body.clientWidth * 0.73 + "px",
      },
      advMargin: {
        //	    	marginTop: -(document.body.clientWidth * 0.27) + 'px',
      },
      noticeTop: {
        top: document.body.clientWidth * 0.96 + "px",
      },
      listL: [],
      listR: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      shopId: 1,
      route_url: "",
      classifyID: 0,
      adv_url: "",
      goodsId: 0,
      lovely_big_title: "",
      lovely_small_title: "",
      time1: 0,
      time2: 0,
      time3: 0,
      order_by: "",
      sort: "desc",
      flags: false,
      scrollWidth: { width: "100%" },
      searchBg: "",
      searchColor: {
        color: "",
      },
      scrollBarW: 0,
      insideSty: {
        width: "",
        left: "0",
      },
      ptAd: false,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.shopId = this.$route.query.shopid;
    this.isiOSX = this.isIphoneX();
    this.getShopInfo();
    //		this.getNotice();
    this.fullReduction();
    this.fullPackage();
    this.getAdList();
  },
  mounted() {
    document
      .querySelector(".supermarket-content")
      .addEventListener("scroll", this.handleScroll);
    document
      .querySelector(".supermarket-swipeBox")
      .addEventListener("scroll", this.handleScroll1);
    document.querySelector("#changeSearch").style.backgroundColor =
      "rgba(" + this.searchBg + ", 0)";
  },
  methods: {
    handleScroll() {
      //页面滚动
      var scrollTop = document.querySelector(".supermarket-content").scrollTop;
      //		  var offsetTop = document.querySelector('#changeSearch').offsetTop;
      var offsetTop = 140;
      //		  this.$toast(scrollTop)
      var point = Number(scrollTop / 140).toFixed(1);
      if (scrollTop > offsetTop) {
        this.supermarketFixedTop = true;
        this.current = 1;
        document.querySelector("#changeSearch").style.backgroundColor =
          "rgba(" + this.searchBg + ", 1)";
      } else {
        this.supermarketFixedTop = false;
        this.current = 0;
        if (point < 0.3) {
          document.querySelector("#changeSearch").style.backgroundColor =
            "rgba(" + this.searchBg + ", 0)";
        } else {
          document.querySelector("#changeSearch").style.backgroundColor =
            "rgba(" + this.searchBg + ", " + point + ")";
        }
      }
    },
    handleScroll1() {
      //分类滚动
      var scrollLeft = document.querySelector(".supermarket-swipeBox")
        .scrollLeft;
      this.insideSty.left =
        (scrollLeft / this.scrollBarW) *
          ((1 - 5 / Math.ceil(this.topCate.length / 2)) * 64) +
        "px";
      //this.scrollBarW 总的滚动条长度
    },
    onChange(index) {
      this.searchBg = this.colorRgb(
        this.swiper[index].background_color
          ? this.swiper[index].background_color
          : ""
      );
      this.searchColor.color = "rgba(" + this.searchBg + ", 1)";
      this.handleScroll();
    },
    colorRgb(sColor) {
      sColor = sColor.toLowerCase();
      //十六进制颜色值的正则表达式
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 如果是16进制颜色
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return sColorChange.join(",");
      }
      return sColor;
    },
    //获取广告
    getAdList() {
      let req = [];
      switch (this.shopId) {
        case "1":
          req = [
            "shallBuy_supermarket_first_top",
            "shallBuy_supermarket_first_middle",
          ];
          break;
        case "2":
          req = [
            "shallBuy_equipment_first_top",
            "shallBuy_equipment_first_middle",
          ];
          break;
        case "5":
          req = ["shallBuy_clothes_first_top", "shallBuy_clothes_first_middle"];
          break;
        case "6":
          req = [
            "shallBuy_jewelry_first_top",
            "shallBuy_jewelry__first_middle",
          ];
          break;
        case "7":
          req = [
            "shallBuy_furniture_first_top",
            "shallBuy_furniture_first_middle",
          ];
          break;
        case "8":
          req = ["shallBuy_typ_first_top", "shallBuy_typ_first_middle"];
          break;
      }
      let _ptTag = adMap[this.shopId];
      this.$api
        .post("/adspace/index/get/ad/list", {
          labels: req.concat([_ptTag]),
        })
        .then((res) => {
          if (res[req[0]] && res[req[0]].length == 0) {
            this.swiper = ["aaa.png"];
          } else {
            this.swiper = res[req[0]];
            this.searchBg = this.colorRgb(
              this.swiper[0].background_color
                ? this.swiper[0].background_color
                : ""
            );
            this.searchColor.color = "rgba(" + this.searchBg + ", 1)";
          }
          this.adv = res[req[1]];
          this.slideLen = res[req[0]].length;
          this.ptAd = res[_ptTag] && res[_ptTag][0];
          if (!this.adv[0]) {
            this.advMargin = {
              marginTop: -(document.body.clientWidth * 0.27) + "px",
            };
          }
        });
    },
    getShopInfo() {
      this.$api
        .post("/activity/index/ad/get-self-index", { self_id: this.shopId })
        .then((res) => {
          this.value = res.hot_search_words;
          if (res.self_data) {
            this.logo = res.self_data.logo;
            this.lovely_big_title = res.self_data.lovely_big_title;
            this.lovely_small_title = res.self_data.lovely_small_title;
            var dise = res.self_data.lovely_merchandise_recommendation;
            if (dise == 1) {
              this.order_by = "approve_time";
            } else if (dise == 2) {
              this.order_by = "sales";
            } else if (dise == 3) {
              this.order_by = { approve_time: "desc", sales: "desc" };
            }
          }

          this.flags = true;
          this.like();

          //         if(res.miaosha_data.list[0]) {
          //         	this.miaosha_data = res.miaosha_data;
          //         	this.miaoshaBegin = this.miaosha_data.orther_config.time_data.begin;
          // 	        var begin_time = this.miaosha_data.orther_config.time_data.begin_time;
          // 	        var end_time = this.miaosha_data.orther_config.time_data.end_time;
          // 	        this.setTimer(1, begin_time, end_time);
          //         }else{
          //         	this.miaoshaShow = false;
          // //      	this.miaosha_data = null;
          //         }
          //过滤掉不需要显示的数据
          for (var i in res.top_cate) {
            if (res.top_cate[i].status == 1) {
              res.top_cate[i].icon = res.top_cate[i].icon || "aaa.png";
              this.topCate.push(res.top_cate[i]);
            }
          }
          //控制分类项高度
          if (this.topCate.length > 5) {
            this.isA1 = true;
          }
          if (this.topCate.length > 10) {
            this.isScroll = true;
            this.scrollWidth.width =
              Math.ceil(this.topCate.length / 2) *
                ((document.body.clientWidth - 16) / 5) +
              "px";
            this.scrollBarW =
              Math.ceil((this.topCate.length - 10) / 2) *
              ((document.body.clientWidth - 16) / 5);
            this.insideSty.width =
              (5 / Math.ceil(this.topCate.length / 2)) * 64 + "px";
          }
        });
    },
    //	getNotice() {//店铺公告  本期不做
    //		this.$api.get("/cms/member/shop/notice/detail", {type: 1, store_id: this.shopId}).then(res => {
    //      this.shopNotic = res.title;
    //    });
    //	},
    fullReduction() {
      //满额立减
      this.$api
        .get("/onshop/index/shop-activity/biggest-discount", {
          self_id: this.shopId,
        })
        .then((res) => {
          if (res.activity.type == undefined || res.goods == null) {
            this.reductionShow = false;
          } else {
            this.reduction_data = res;

            var begin_time = this.date2timestamp(
              this.reduction_data.activity.begin_time
            );
            var end_time = this.date2timestamp(
              this.reduction_data.activity.end_time
            );
            this.setTimer(2, begin_time, end_time);
          }
        });
    },
    fullPackage() {
      //满额包邮
      this.$api
        .get("/onshop/index/postage-activity/lowest-requirement", {
          self_id: this.shopId,
        })
        .then((res) => {
          if (res.activity.type == undefined || res.goods == null) {
            this.fullpackageShow = false;
          } else {
            this.fullpackage_data = res;

            var begin_time = this.date2timestamp(
              this.fullpackage_data.activity.begin_time
            );
            var end_time = this.date2timestamp(
              this.fullpackage_data.activity.end_time
            );
            this.setTimer(3, begin_time, end_time);
          }
        });
    },
    like() {
      //猜你喜欢
      if (this.page == 0 || !this.flags) {
        return;
      }
      this.$api
        .post("/ongoods/index/goods/guess-like", {
          self_id: this.shopId,
          page: this.page,
        })
        .then((res) => {
          if (this.order_by) {
            this.allList = res.total;
            if (res.list.length > 0) {
              // for(let i in res.list) {
              // 	this.list.push(res.list[i]);
              // }
              res.list.forEach((item, i) => {
                if (i % 2 == 0) {
                  this.listL.push(item);
                } else {
                  this.listR.push(item);
                }
              });
            }
            this.loading = false;
            if (this.listL.length + this.listR.length >= this.allList) {
              // 数据全部加载完成
              this.finished = true;
            }
            if (this.isLoading) {
              this.$toast("刷新成功");
              this.isLoading = false;
            }
          }
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.like();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.listL = [];
      this.listR = [];
      this.like();
    },
    setTimer(flag, begin_time, end_time) {
      //flag：1秒杀  2满额立减  3满额包邮
      // if(flag == 1){
      // 	var current = Math.floor(new Date().getTime() / 1000);
      // 	var starts = begin_time - current;
      // 	var ts = end_time - current;
      // 	if (ts <= 0 || starts > 0) {
      // 		//倒计时结束
      // 		this.miaoshaShow = false;
      // 	}else {
      // 		var current = Math.floor(new Date().getTime());
      // 			this.time1 = Number(end_time+'000') - current;
      // 	}
      // }else
      if (flag == 2) {
        var current = Math.floor(new Date().getTime() / 1000);
        var starts = begin_time - current;
        var ts = end_time - current;
        if (ts <= 0 || starts > 0) {
          //倒计时结束
          this.reductionShow = false;
        } else {
          var current = Math.floor(new Date().getTime());
          this.time2 = Number(end_time + "000") - current;
        }
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var starts = begin_time - current;
        var ts = end_time - current;
        if (ts <= 0 || starts > 0) {
          //倒计时结束
          this.fullpackageShow = false;
        } else {
          var current = Math.floor(new Date().getTime());
          this.time3 = Number(end_time + "000") - current;
        }
      }
    },
    goBack() {
      //返回
      this.params("", "", "goBack");
    },
    supportSM() {
      //分享
      this.params("", "", "supportSM");
    },
    searchSM() {
      //搜索
      this.params(this.value, this.value, "searchSM");
    },
    Router(router) {
      //轮播
      if (router) {
        this.invokeStat("List_supermarket_banner1");
        this.route_url = router;
        this.goRouterSM();
      }
    },
    goRouterSM() {
      //轮播
      this.params(this.route_url, this.route_url, "goRouterSM");
    }, //classifyID
    classify1(id) {
      //分类
      this.classifyID = id;
      this.classifySM();
    },
    classifySM() {
      //分类
      this.params(this.classifyID, this.classifyID, "classifySM");
    },
    noticeSM() {
      //公告
      this.params("", "", "noticeSM");
    },
    dftAdv(router) {
      this.invokeStat("List_supermarket_banner2");
      //广告位
      this.adv_url = router;
      this.adv_methodSM();
    },
    ptAdv(router) {
      this.invokeStat("List_supermarket_banner3");
      this.adv_url = router;
      this.adv_methodSM();
    },
    adv_methodSM() {
      //广告位
      this.params(this.adv_url, this.adv_url, "adv_methodSM");
    },
    moreDayrecSM() {
      //每日好货more
      this.params("", "", "moreDayrecSM");
    }, //goodsId
    goDetail1(id) {
      //商品详情
      this.goodsId = id;
      this.goDetailSM();
    },
    goDetailSM() {
      //商品详情
      this.params(this.goodsId, this.goodsId, "goDetailSM");
    },
    moreSpikeSM() {
      //每日秒杀more
      this.params("", "", "moreSpikeSM");
    },
    fullpackageSM() {
      //满额包邮
      this.params("", "", "fullpackageSM");
    },
    reductionSM() {
      //满额立减
      this.params("", "", "reductionSM");
    },
    advDefault() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    iconDefu() {
      var img = event.srcElement;
      img.src = defaultIcon;
      img.onerror = null; //防止闪图
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
  },
  destroyed() {
    document
      .querySelector(".supermarket-content")
      .removeEventListener("scroll", this.handleScroll);
    document
      .querySelector(".supermarket-swipeBox")
      .removeEventListener("scroll", this.handleScroll1);
  },
};
</script>

<style lang="less">
.supermarket {
  height: 100%;
  background: #fff;
  position: relative;
  &-search {
    position: fixed;
    top: 0px;
    left: 0;
    z-index: 10;
    padding: 0;
    width: 100%;
    padding-top: 21px;
    /*background: rgba(0,0,0,0) !important;*/
    .back {
      width: 15px;
      padding: 8px;
      position: fixed;
      top: 29px;
      left: 16px;
      z-index: 9;
    }
    h2 {
      text-align: center;
      margin: 10px 0 0;
      .littleTitle {
        /*width: 75px;*/
        height: 25px;
      }
    }
    .search {
      width: 16px;
      position: absolute;
      bottom: 15px;
      left: 31px;
      z-index: 9;
    }
    .share {
      width: 22px;
      position: fixed;
      top: 43px;
      right: 17px;
      z-index: 9;
    }
    .van-search {
      padding: 6px 16px;
      background: rgba(0, 0, 0, 0) !important;
      .van-field__control {
        color: #999;
        font-size: 14px;
      }
      input::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #999 !important;
        font-size: 14px;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #999 !important;
        font-size: 14px;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #999 !important;
        font-size: 14px;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #999 !important;
        font-size: 14px;
      }
      .van-search__content {
        padding-left: 0;
        background: rgba(0, 0, 0, 0) !important;
      }
      .van-cell {
        padding: 5px 15px 5px 38px;
        border-radius: 17px;
        background: #fff;
        .van-field__left-icon {
          display: none;
        }
      }
    }
  }
  &-content {
    height: 100%;
    position: relative;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .supermarket-swipe {
      .item {
        width: 100%;
      }
      .van-swipe__indicators {
        bottom: 117px;
      }
      .van-swipe__indicator {
        width: 12px;
        height: 3px;
        border-radius: 2px;
        background-color: #fff;
        opacity: 0.5;
        -webkit-transition: opacity 0.5s;
        transition: opacity 0.5s;
      }
      .van-swipe__indicator--active {
        background-color: #fff;
        opacity: 1;
        -webkit-transition: opacity 0.5s;
        transition: opacity 0.5s;
      }
      .van-swipe__indicator:not(:last-child) {
        margin-right: 7px;
      }
    }
    .supermarket-adv {
      padding: 0 16px;
      /*margin-top: -101px;*/
      position: absolute;
      top: 275px;
      left: 0;
      img {
        width: 100%;
        min-height: 65px;
        display: block;
      }
    }
    .supermarket-notice {
      /*position: relative;*/
      /*margin-top: 15px;*/
      position: absolute;
      top: 360px;
      left: 0;
      width: 100%;
      .van-col {
        padding: 0 21px;

        img {
          position: absolute;
          width: 24px;
          top: 10px;
          left: 21px;
          z-index: 8;
        }
        .hot {
          color: #ff5019;
          font-size: 11px !important;
          width: 32px;
          height: 18px;
          line-height: 18px;
          background: rgba(255, 80, 25, 0.1);
          position: absolute;
          top: 8px;
          left: 52px;
          z-index: 8;
          text-align: center;
        }
        .van-notice-bar {
          padding-left: 67px;
          height: 34px;
          color: #555;
          font-size: 13px;
          background: rgba(0, 0, 0, 0);
        }
      }
    }
    .supermarket-model1 {
      position: relative;
      z-index: 9;
      padding: 6px 8px 0;
      .content {
        height: 85px;
        overflow-x: scroll;
        overflow-y: hidden;
        .swipeBox {
          .label {
            text-align: center;
            float: left;
            .classfity {
              color: #777;
              height: 14px;
              font-size: 12px;
              margin: 5px 0 14px;
            }
          }
        }
      }
      .class-a {
        height: 184px !important;
        padding-bottom: 10px;
        .swipeBox {
          height: 184px;
        }
      }
      img {
        width: 44px;
        height: 44px;
        margin-bottom: 8px;
        vertical-align: bottom;
        display: inline-block;
      }
      .scrollBar {
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 100%;
        text-align: center;
        .outside {
          width: 64px;
          height: 2px;
          display: inline-block;
          background: rgba(29, 30, 31, 0.2);
          border-radius: 2px;
          position: relative;
          .inside {
            height: 2px;
            border-radius: 2px;
            background: #1d1e1f;
            position: absolute;
            top: 0;
          }
        }
      }
    }
    .model1-scroller {
      height: 184px !important;
      overflow: hidden;
    }
    .supermarket-spike {
      padding: 12px 16px 0;
      .box {
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0px 8px 24px rgba(238, 238, 238, 0.8);
        .title {
          color: #454645;
          font-size: 16px;
          padding: 18px 12px 0;
          height: 48px;
          img {
            width: 97px;
            float: left;
            margin-right: 12px;
          }
          span {
            width: 32px;
            height: 30px;
            line-height: 30px;
            color: #fff;
            font-size: 18px;
            text-align: center;
            border-radius: 3px;
            display: inline-block;
            background: -webkit-linear-gradient(
              #616161,
              #3b3b3b
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              #616161,
              #3b3b3b
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              #616161,
              #3b3b3b
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(#616161, #3b3b3b);
          }
        }
        .label {
          padding-left: 16px;
          margin-top: 14px;
          color: #1d1e1f;
          .time {
            color: #fff;
            font-size: 12px;
            width: 89px;
            height: 23px;
            line-height: 23px;
            border-radius: 3px;
            display: inline-block;
            text-align: center;
            background: -webkit-linear-gradient(
              to right,
              #ff4444,
              #ff8888
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              to right,
              #ff4444,
              #ff8888
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              to right,
              #ff4444,
              #ff8888
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #ff4444, #ff8888);
          }
        }
        .more {
          font-size: 14px;
          color: #ff4a4a;
          text-align: right;
          padding-right: 16px;
          height: 23px;
          line-height: 23px;
          margin-top: 14px;
          img {
            width: 9px;
            float: right;
            margin-top: 5px;
          }
        }
        .wrapper {
          width: 100%;
          background: #fff;
          .datePrice {
            width: 100%;
            overflow-x: scroll;
            padding-top: 12px;
            .clearfix {
              overflow: hidden;
              white-space: nowrap;
              width: 100%;
              li {
                float: left;
                margin-right: 12px;
                background: #ffffff;
                position: relative;
                overflow: hidden;
                .imgCon {
                  width: 100%;
                  background: #ffffff;
                  border-radius: 3px;
                  position: relative;
                  .imgPro {
                    width: 100%;
                    height: 100%;
                    border-radius: 3px;
                    display: block;
                  }
                  .reback {
                    width: 14px;
                    display: inline-block;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                  }
                }
                .name {
                  font-size: 12px;
                  color: #333;
                  margin: 4px 0 2px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  height: 20px;
                  line-height: 20px;
                }
                .price {
                  font-size: 13px;
                  color: #ff5959;
                  margin: 0;
                  height: 21px;
                  line-height: 21px;
                  margin-bottom: 12px;
                  del {
                    font-size: 10px;
                    color: #bbb;
                    margin-left: 3px;
                  }
                }
              }
              li:nth-child(1) {
                margin-left: 12px;
              }
              /*li.empty {
								width: 4px;
								margin-right: 0px;
								color: rgba(0, 0, 0, 0);
								background: rgba(0, 0, 0, 0);
							}*/
            }
          }
        }
      }
    }
    .supermarket-dayrec {
      padding: 0 16px;
      margin-top: 20px;
      .wrap {
        box-shadow: 0px 8px 24px rgba(238, 238, 238, 0.8);
        .box {
          background: url(../../assets/selfSupport/meirihaohuobg.png) no-repeat
            center center;
          height: 80px;
          background-size: 100% 100%;
          padding: 0 16px;
        }
        .title {
          padding-top: 17px;
          .word {
            width: 84px;
            float: left;
          }
          .more {
            width: 24px;
            float: left;
            margin-left: 12px;
          }
        }
        .label {
          span {
            color: #fff;
            font-size: 12px;
            height: 33px;
            line-height: 33px;
            display: inline-block;
            text-align: center;
            img {
              width: 7px;
            }
          }
        }
        .dayrec-list {
          padding: 0 16px;
          padding: 6px;
          background: #fff;
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
          .van-col {
            padding: 6px;
            img {
              border-radius: 3px;
              background: #fff;
              width: 100%;
              display: block;
            }
          }
        }
      }
    }
    .supermarket-active {
      padding: 20px 16px;
      .wrap {
        height: auto;
        background: #fff;
        border-radius: 3px;
        box-shadow: 0px 8px 24px rgba(238, 238, 238, 0.8);
        .tit {
          padding: 16px;
          color: #fff;
          background: url(../../assets/selfSupport/classifyOne.png) no-repeat
            center center;
          background-size: 100% 100%;
          .van-col {
            height: 25px;
            line-height: 25px;
          }
          .leftB,
          .rightB {
            height: 20px;
            line-height: 20px;
            span {
              color: #f8e71c;
            }
          }
          .leftT {
            font-size: 18px;
            span {
              line-height: 17px;
              float: left;
              padding-top: 2px;
            }
            img {
              width: 18px;
              margin-left: 6px;
            }
          }
          .leftB,
          .rightT {
            font-size: 12px;
          }
          .rightT,
          .rightB {
            text-align: right;
          }
          .rightB {
            font-size: 10px !important;
            .van-count-down {
              color: #fff;
            }
            span {
              color: #4f80f3;
              font-size: 12px;
              height: 17px;
              line-height: 17px;
              text-align: center;
              background: #fff;
              border-radius: 2px;
              display: inline-block;
              margin: 0 2px;
              min-width: 15px;
              padding: 0 2px;
            }
          }
        }
        .product {
          padding: 12px 6px;
          .van-col {
            padding: 0 6px;
            .img {
              position: relative;
              .imgPro {
                border-radius: 3px;
                width: 100%;
                display: block;
              }
              .reback {
                width: 14px;
                display: inline-block;
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }
            .name {
              font-size: 12px;
              color: #333;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              height: 20px;
              line-height: 20px;
              margin: 4px 0 2px;
            }
            .price {
              font-size: 15px;
              color: #f24724;
              margin: 0;
              height: 21px;
              line-height: 21px;
            }
          }
        }
      }
    }
    .supermarket-active2 {
      padding: 0 16px 32px;
      .wrap {
        height: auto;
        .tit {
          background: url(../../assets/selfSupport/classifyTwo.png) no-repeat
            center center;
          background-size: 100% 100%;
          .rightB {
            span {
              color: #ff4a4a;
            }
          }
        }
      }
    }
    .supermarket-like {
      width: 100%;
      background: #fff;
      .title {
        padding: 0 16px 16px;
        background: -webkit-linear-gradient(
          #f8f8f8,
          #fff
        ); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#f8f8f8, #fff); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#f8f8f8, #fff); /* Firefox 3.6 - 15 */
        background: linear-gradient(#f8f8f8, #fff);
        p {
          margin: 0;
          height: 25px;
          line-height: 25px;
          color: #333;
          font-size: 18px;
          .label {
            width: 19px;
            height: 25px;
            background: #f8e71c;
            border-radius: 10px;
            float: left;
          }
          .like {
            float: left;
            color: #333;
            font-size: 18px;
            margin-left: -15px;
          }
          .tip {
            color: #999;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            float: left;
            margin-top: 3px;
            margin-left: 17px;
          }
        }
      }
      .van-col--12 {
        .goods {
          .img {
            position: relative;
            .imgPro {
              width: 100%;
              display: block;
              border-radius: 5px;
            }
            .reback {
              width: 14px;
              display: inline-block;
              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .label {
            margin-top: 9px;
          }
          .name {
            color: #333;
            font-size: 14px;
            height: 42px;
            line-height: 21px;
            overflow: hidden;
            margin-top: 6px;
            // text-overflow: ellipsis;
            display: -webkit-box;
            // -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            img {
              vertical-align: middle;
              margin-right: 10px;
              height: 20px;
            }
          }
          .price {
            height: 25px;
            line-height: 25px;
            color: #ff3b30;
            font-size: 18px;
            margin: 4px 0 8px;
            del {
              color: #bbbbbb;
              font-size: 12px;
            }
          }
        }
        .leftGoods {
          padding: 0 4px 0 16px;
        }
        .rightGoods {
          padding: 0 16px 0 4px;
        }
      }
    }
    .supermarket-end {
      height: 50px;
      line-height: 50px;
      background: #f5f6f7;
      text-align: center;
      .end-word {
        position: relative;
        color: #ccc;
        font-size: 13px;
        background: #f5f6f7;
        span {
          width: 40px;
          height: 1px;
          background: #ddd;
          position: absolute;
          top: 6px;
        }
        .left {
          left: -48px;
        }
        .right {
          right: -48px;
        }
      }
    }
  }
  .label_zy {
    width: 34px;
    height: 13px;
    line-height: 13px;
    border-radius: 2px;
    background: #e95a27;
    border: solid 1px #e95a27;
    color: #ffffff;
    font-size: 11px;
    margin-right: 6px;
    text-align: center;
    padding: 0;
    display: inline-block;
  }
  .label_mj {
    color: #ef5454;
    border: solid 1px #ef5454;
    background: #ffffff;
  }
  .label_by {
    color: #f5a359;
    border: solid 1px #f5a359;
    background: #ffffff;
  }
}

.supermarketFixedTop {
  .littleTitle {
    display: none;
  }
  .search {
    left: 58px;
    top: 37px;
  }
  h2 {
    margin: 0;
  }
  .van-search__content {
    padding-left: 26px !important;
    padding-right: 42px;
  }
  .van-cell {
    background: #f2f2f2 !important;
    /*.van-field__control {
			color: #8BC78B;
		}
		input::-webkit-input-placeholder {
		  color: #8BC78B !important;
		}
		input:-moz-placeholder {
		  color: #8BC78B !important;
		}
		input::-moz-placeholder {
			color: #8BC78B !important;
		}
		input:-ms-input-placeholder {
		  color: #8BC78B !important;
		}*/
  }
}

.isiOSX {
  padding-top: 41px;
  .back {
    top: 49px;
  }
  .search {
    top: 104px;
  }
  .search1 {
    top: 57px;
  }
  .share {
    top: 63px;
  }
}

// 拼团活动
.groupbuy {
  margin: 20px 16px;
  width: calc(100% - 32px);
  height: 148px;
  border-radius: 3px;
  overflow: hidden;
}
</style>
